import './assumptions.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons'
import '../question/validation-message.scss';
import classNames from 'classnames';
import { GetAssumptionsList } from '../../functions/AssumptionsList';

export default function Assumptions(props: any) {

    var confirmClassNames = classNames(
        {
            'confirm-assumption': true,
            'confirmed-assumption': props.confirmedAssumptions,
            'assumption-validation-fail': props.validationFail
        }
    );

    var labelClasses = classNames(
        {
            'assumptions-confirm-text': true,
            'validation-fail-lbl': props.validationFail
        }
    );

    var updateClassNames = classNames(
        {
            'assumption-validation-fail': props.validationFail
        }
    );

    var assumptionsList = GetAssumptionsList();

    return (
        <div className="assumptions">
            <div className="section-header">Assumptions we've made</div>
            <p>We have based the quote on a number of assumptions about your business.</p>
            <p>They impact your cover so it is important you review each one and make any necessary changes to ensure the insurance we offer you is appropriate to your business.</p>

            <ul>
                {assumptionsList.map((assumption: string) => {
                    return <li>{assumption}</li>
                })}
            </ul>

            <p className={labelClasses}>Select an option below to confirm that these assumptions are correct</p>
            <div className="assumptions-button-container">
            <button
                id="valen_assumption_confirm"
                className={confirmClassNames}
                onClick={() => props.confirmAssumptions()}
            ><FontAwesomeIcon className="tick-icon-assumption" icon={faCircleCheck} /> Yes, I confirm these are correct</button>

                <button id="valen_assumption_update" className={updateClassNames} onClick={() => props.updateAssumptions()}>No, I'd like to update</button>

                {props.validationFail &&
                    <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please confirm the assumptions we've made are correct, if not you must update</div>
                }
            </div>
        </div>
    );
}
